<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Quản lý node</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Danh sách node</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm"
                      placeholder="Search"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
            <el-table-column
              :min-width="120"
              class-name="td-actions"
              label="Actions">
              <template slot-scope="props">
                <p-button title="Điều khiển" type="info" size="sm" icon @click="handleConfig(props.$index, props.row)">
                  <i class="fa fa-cog"></i>
                </p-button>
                <p-button title="Hẹn giờ" type="success" size="sm" icon @click="handleAlarm(props.$index, props.row)">
                  <i class="fa fa-clock-o"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Hiển thị {{from + 1}} đến {{to}} trong {{total}} thiết bị</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
    <NodeControl
            v-bind:nodeIndex="nodeIndex"
            v-bind:tableData="nodeData">
    </NodeControl>
    <Timing
            v-bind:nodeIndex="nodeIndex"
            v-bind:tableData="nodeData">
    </Timing>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  
  import NodeControl from './NodeControl.vue'
  import Timing from './Timing.vue'
  import axios from "axios";
  import VueAxios from "vue-axios";
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination,
      NodeControl,
      Timing
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        let permission = JSON.parse(localStorage.getItem('permission'));        // Permission got from login
        let privilege = ''
        if (permission != 0) {
          privilege = JSON.parse(localStorage.getItem('privilege'));        // Privilege got from login
          this.pagination.total = Object.keys(privilege).length;
          return Object.keys(privilege).length
        } else {
          this.pagination.total = this.tableData.length
          return this.tableData.length
        }
      }
    },
    data () {
      return {
        timer:'',
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['id'],
        tableColumns: [
          {
            prop: 'id',
            label: 'Id',
            minWidth: 120
          },
          {
            prop: 'name',
            label: 'Tên',
            minWidth: 120
          },
          {
            prop: 'coor',
            label: 'Tọa độ',
            minWidth: 150
          },
          {
            prop: 'stat',
            label: 'Trạng thái',
            minWidth: 120
          }
        ],
        tableData: [],
        nodeData: [],
        nodeIndex: 0
      }
    },
    created(){
      this.loadData();
      this.timer = setInterval(this.loadData, 5000);     
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    methods: {
      loadData(){
        let permission = JSON.parse(localStorage.getItem('permission'));        // Permission got from login
        let privilege = ''
        if (permission != 0) {
          privilege = JSON.parse(localStorage.getItem('privilege'));        // Privilege got from login
        }
        
        // console.log(privilege);
        this.axios.get('/LoraNode/LoraViewNode').then(response => {         
          this.tableData = response.data;
          //this.tableData.shift();       // delte the first node (id = 0) since it doesn't exist
          var i;
          for (i = 0; i < this.tableData.length; i++) { 
            this.tableData[i].coor = this.tableData[i].latitude + ", " + this.tableData[i].longitude;
            if (this.tableData[i].status == 1) {
              this.tableData[i].stat = "Mất kết nối!";
            }
            else 
            {
              var j;
              this.tableData[i].stat = "";
              for (j = 1; j <= 10; j++)
              {
                this.tableData[i].stat += this.tableData[i]["s"+j] == 0 ? "o":"x";
              } 
            }
            
          }
          if (permission != 0) {
            for (i = 0; i < this.tableData.length; i++) { 
              if (privilege[this.tableData[i].id]) {         // If specified in privilege
                
              } else {
                this.tableData.splice(i, 1);           //If not specified in privilege, delete node data
                i -= 1;
              }
            }
          }
        }).catch(error => {
          console.log(error)
        });
      },
      handleConfig (index, row) {
        let permission = JSON.parse(localStorage.getItem('permission'));        // Permission got from login
        let privilege = JSON.parse(localStorage.getItem('privilege'));        // Privilege got from login
        let switchAmount = 0;
        this.nodeIndex = row.id;
        this.nodeData = [];
        if (permission != 0) {        
          switchAmount = privilege[this.nodeIndex].length;
          if (switchAmount == 0){
            switchAmount = 10;
            privilege[this.nodeIndex].push(1,2,3,4,5,6,7,8,9,10);
          }
        } else {
          switchAmount = 10;
          privilege = {[this.nodeIndex] : [1,2,3,4,5,6,7,8,9,10]};
        }

        var i;
        const that = this;
        const token = localStorage.getItem('token');
        let data = {
          tokenkey: token,
          id: this.nodeIndex,
        }
        let alarm = {};
        axios({url: '/LoraNode/LoraViewAlarm', 
              data: data, 
              method: 'POST' })
        .then(function(res){
          alarm = res.data.Alarms;   
          for (i = 0; i < switchAmount; i++)
          {
            let j = privilege[row.id][i];
            if (alarm[j]) {
              that.nodeData.push({
                region: row.name,
                port: j,
                active: (row["s" + j] == 0),
                houron1: alarm[j].hour_on1 >= 99 ? '--' : that.pad(alarm[j].hour_on1),
                minon1: alarm[j].minute_on1 >= 99 ? '--' : that.pad(alarm[j].minute_on1),
                houroff1: alarm[j].hour_off1 >=99 ? '--' : that.pad(alarm[j].hour_off1),
                minoff1: alarm[j].minute_off1 >= 99 ? '--' : that.pad(alarm[j].minute_off1),
                houron2: alarm[j].hour_on2 >= 99 ? '--' : that.pad(alarm[j].hour_on2),
                minon2: alarm[j].minute_on2 >= 99 ? '--' : that.pad(alarm[j].minute_on2),
                houroff2: alarm[j].hour_off2 >= 99 ? '--' : that.pad(alarm[j].hour_off2),
                minoff2: alarm[j].minute_off2 >= 99 ? '--' : that.pad(alarm[j].minute_off2),
              })   
            } else {
              that.nodeData.push({
                region: row.name,
                port: j,
                active: (row["s" + j] == 0),
                houron1: '--',
                minon1: '--',
                houroff1: '--',
                minoff1: '--',
                houron2: '--',
                minon2: '--',
                houroff2: '--',
                minoff2: '--',
              })   
            }      
          }   
          //document.getElementById('node_control').style.transform='scale(0.7)';
          document.getElementById('node_control').style.display='block';       

          return(res)
        })
        .catch(function(err){
          alert('Tải dữ liệu thất bại');
          console.log(err);
          return(err)
        })
        
       
      },
      handleAlarm (index, row) {
        let permission = JSON.parse(localStorage.getItem('permission'));        // Permission got from login
        let privilege = JSON.parse(localStorage.getItem('privilege'));        // Privilege got from login
        let switchAmount = 0;
        this.nodeIndex = row.id;
        this.nodeData = [];
        if (permission != 0) {        
          switchAmount = privilege[this.nodeIndex].length;
          if (switchAmount == 0){
            switchAmount = 10;
            privilege[this.nodeIndex].push(1,2,3,4,5,6,7,8,9,10);
          }
        } else {
          switchAmount = 10;
          privilege = {[this.nodeIndex] : [1,2,3,4,5,6,7,8,9,10]};
        }

        var i;
        for (i = 0; i < switchAmount; i++)
        {
          this.nodeData.push({
            region: row.name,
            port: privilege[row.id][i],
            active: (row["s" + privilege[row.id][i]] == 0)
          })         
        }   
        document.getElementById('timing').style.display='block';
      },
      pad(d) {
        return (d < 10) ? '0' + d.toString() : d.toString();
      }
    }
  }
</script>
<style lang="scss">
  .el-table .td-actions{
    button.btn {
     margin-right: 5px;
    }
  }
</style>
